
        var result = require("!!../../../../node_modules/css-loader/index.js!./employee-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/employees/employee-details/employee-list.component.css
// module id = 2430
// module chunks = 1